import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faDatabase, faIdCard, faUserTie, faUsers, faFileContract, faHandshake, faUserFriends, faStethoscope, faUser,
  faClipboardCheck, faMoneyBillWave, faGift, faExclamationTriangle, faMinusCircle, faBed, faBandAid, faMapMarkerAlt,
  faMoneyCheck, faBullhorn, faChalkboardTeacher, faTasks, faUserSlash, faClock, faAmbulance, faCertificate,
  faIdBadge
} from '@fortawesome/free-solid-svg-icons';
import './ThinkContract.css';
// import thinkhealthimage from '../../assets/pageimages/thinkhealthimage.webp';

function ThinkContractContractor() {

  const LinkButton = ({ to, icon, label }) => (
    <div className="flex justify-center">
      <Link
        to={to}
        className="flex items-center flex-wrap justify-center p-3 w-full bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-all duration-300"
      >
        <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
        <span>{label}</span>
      </Link>
    </div>
  );

  const LinkNoButton = ({ to, icon, label }) => (
    <div className="flex justify-center">
      <Link
        to={to}
        className="flex items-center flex-wrap justify-center p-3 w-full bg-gray-200 text-gray-800 font-semibold rounded-lg hover:bg-gray-300 transition-all duration-300"
      >
        <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
        <span>{label}</span>
      </Link>
    </div>
  );

  return (
    <MainLayout>
      <div className="mt-12 text-sm min-h-screen bg-gradient-to-r from-purple-600 via-purple-700 to-purple-800 flex flex-col items-center py-8">
        <p className="text-xl font-bold text-white text-center mb-4">Contractor Dashboard </p>
        {/* <img
          src={thinkhealthimage}
          alt="ThinkHealth"
          className="w-1/3 h-auto max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl rounded-lg shadow-lg flex-wrap"
        /> */}

        <div className="flex-grow">
          <div className="grid grid-cols md:grid-cols lg:grid-cols-5 gap-4 p-4 bg-gray-600 rounded-lg shadow-lg transition-transform transform hover:scale-105 mx-4 mt-6">
            <LinkButton to="/think-contract-contractor-profile" icon={faDatabase} label="Master Record" />
            <LinkNoButton to="" icon={faIdCard} label="License" />
            <LinkNoButton to="" icon={faIdBadge} label="Contractor Card" />
            <LinkNoButton to="" icon={faUserTie} label="Manager" />
            <LinkNoButton to="" icon={faUsers} label="My Sub-Contractors" />
            <LinkNoButton to="" icon={faUser} label="I am Sub-Contracting" />
            <LinkButton to="/think-contract-contractor-agreement-list" icon={faFileContract} label="Principal Employers Contracts" />
            <LinkButton to="/think-contract-subcontractor-agreement-list" icon={faHandshake} label="Sub-Contractors Contracts" />
            <LinkNoButton to="" icon={faUserFriends} label="Workers" />
            <LinkNoButton to="" icon={faClipboardCheck} label="Attendance" />
            <LinkNoButton to="" icon={faMoneyBillWave} label="Salary & Wages" />
            <LinkNoButton to="" icon={faGift} label="Bonus" />
            <LinkNoButton to="" icon={faExclamationTriangle} label="Fine" />
            <LinkNoButton to="" icon={faMinusCircle} label="Deductions" />
            <LinkNoButton to="" icon={faMoneyCheck} label="Advance" />
            <LinkNoButton to="" icon={faBullhorn} label="Grievances" />
            <LinkNoButton to="" icon={faChalkboardTeacher} label="Trainings" />
            <LinkNoButton to="" icon={faTasks} label="Tasks" />
            <LinkNoButton to="" icon={faUserSlash} label="Terminations" />
            <LinkNoButton to="" icon={faClock} label="Overtime" />
            <LinkNoButton to="" icon={faAmbulance} label="Accidents" />
            <LinkNoButton to="" icon={faBed} label="Rest Days" />
            <LinkNoButton to="" icon={faCertificate} label="Skill Certificate" />
            <LinkNoButton to="" icon={faStethoscope} label="Medical Examinations" />
            <LinkNoButton to="" icon={faBandAid} label="Injury" />
            <LinkNoButton to="" icon={faMapMarkerAlt} label="Work Location" />


          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default ThinkContractContractor;
